<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <g fill-rule="evenodd">
    <path
      d="m471.95 253.05c0 120.9-98.01 218.9-218.9 218.9-120.9 0-218.9-98.01-218.9-218.9 0-120.9 98.01-218.9 218.9-218.9 120.9 0 218.9 98.01 218.9 218.9"
      fill="#0078ad"
    />
    <path
      d="m256 106c-82.84 0-150 67.16-150 150 0 41.674 16.999 79.38 44.44 106.56.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.021.02.041.042.063.063.598.609 1.204 1.214 1.813 1.813l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.126.124.249.252.375.375.207.209.417.417.625.625.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.332.335.665.668 1 1 .374.378.747.751 1.125 1.125.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.021.02.041.042.063.063.469.478.931.966 1.406 1.438.461.465.939.916 1.406 1.375l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.184.18.378.352.563.531.149.151.287.319.438.469.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.126.124.249.252.375.375.207.209.417.417.625.625.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.285.289.587.557.875.844.113.116.231.228.344.344.306.308.598.632.906.938.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.021.02.041.042.063.063.598.609 1.204 1.214 1.813 1.813l.094.094c.126.124.249.252.375.375.332.335.665.668 1 1 .374.378.747.751 1.125 1.125.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.186.179.376.353.563.531.098.1.183.213.281.313l.219.219c.598.609 1.204 1.214 1.813 1.813l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.126.124.249.252.375.375.207.209.417.417.625.625.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.126.124.249.252.375.375.207.209.417.417.625.625.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.332.335.665.668 1 1 .374.378.747.751 1.125 1.125.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.021.02.041.042.063.063.469.478.931.966 1.406 1.438.461.465.939.916 1.406 1.375l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.186.179.376.353.563.531.098.1.183.213.281.313l.219.219c.598.609 1.204 1.214 1.813 1.813l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.126.124.249.252.375.375.207.209.417.417.625.625.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.285.289.587.557.875.844.113.116.231.228.344.344.306.308.598.632.906.938.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.021.02.041.042.063.063.598.609 1.204 1.214 1.813 1.813l.094.094c.126.124.249.252.375.375.332.335.665.668 1 1 .374.378.747.751 1.125 1.125.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.186.179.376.353.563.531.098.1.183.213.281.313l.219.219c.598.609 1.204 1.214 1.813 1.813l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.184.18.378.352.563.531.149.151.287.319.438.469.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.166.167.333.333.5.5.126.124.249.252.375.375.207.209.417.417.625.625.186.179.376.353.563.531.098.1.183.213.281.313l.156.156c.011.01.021.021.031.031.609.62 1.225 1.235 1.844 1.844l.094.094c.126.124.249.252.375.375.332.335.665.668 1 1 .374.378.747.751 1.125 1.125.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.021.02.041.042.063.063.469.478.931.966 1.406 1.438.461.465.939.916 1.406 1.375l.094.094c.126.124.249.252.375.375.374.378.747.751 1.125 1.125.494.499.999.977 1.5 1.469.005.005-.005.026 0 .031.186.179.376.353.563.531.098.1.183.213.281.313l.219.219c.413.42.832.835 1.25 1.25 115.59-3.465 208.66-96.54 212.13-212.12-.436-.439-.871-.879-1.313-1.313-.148-.154-.32-.284-.469-.438-.081-.085-.169-.165-.25-.25-.099-.098-.182-.215-.281-.313-.204-.212-.42-.414-.625-.625-.126-.124-.249-.251-.375-.375-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.15-.15-.318-.288-.469-.438-.081-.085-.169-.165-.25-.25-.104-.103-.208-.21-.313-.313-.179-.186-.352-.378-.531-.563-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.49-.499-.972-1.01-1.469-1.5-.497-.502-1.027-.974-1.531-1.469-.087-.09-.163-.191-.25-.281-.095-.093-.186-.189-.281-.281-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.148-.154-.32-.284-.469-.438-.081-.085-.169-.165-.25-.25-.099-.098-.182-.215-.281-.313-.204-.212-.42-.414-.625-.625-.126-.124-.249-.251-.375-.375-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.148-.154-.32-.284-.469-.438-.081-.085-.169-.165-.25-.25-.099-.098-.182-.215-.281-.313-.148-.154-.32-.284-.469-.438-.182-.18-.349-.383-.531-.563-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.15-.15-.318-.288-.469-.438-.081-.085-.169-.165-.25-.25-.104-.103-.208-.21-.313-.313-.179-.186-.352-.378-.531-.563-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.335-.335-.662-.668-1-1-.655-.667-1.333-1.314-2-1.969-.087-.09-.163-.191-.25-.281-.095-.093-.186-.189-.281-.281-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.276-.276-.566-.539-.844-.813-.058-.056-.098-.131-.156-.188-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.148-.154-.32-.284-.469-.438-.081-.085-.169-.165-.25-.25-.099-.098-.182-.215-.281-.313-.204-.212-.42-.414-.625-.625-.126-.124-.249-.251-.375-.375-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.15-.15-.318-.288-.469-.438-.081-.085-.169-.165-.25-.25-.104-.103-.208-.21-.313-.313-.179-.186-.352-.378-.531-.563-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.49-.499-.972-1.01-1.469-1.5-.497-.502-1.027-.974-1.531-1.469-.092-.095-.189-.186-.281-.281-.089-.087-.16-.194-.25-.281-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.148-.154-.32-.284-.469-.438-.081-.085-.169-.165-.25-.25-.099-.098-.182-.215-.281-.313-.204-.212-.42-.414-.625-.625-.126-.124-.249-.251-.375-.375-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.148-.154-.32-.284-.469-.438-.081-.085-.169-.165-.25-.25-.099-.098-.182-.215-.281-.313-.204-.212-.42-.414-.625-.625-.126-.124-.249-.251-.375-.375-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.15-.15-.318-.288-.469-.438-.081-.085-.169-.165-.25-.25-.104-.103-.208-.21-.313-.313-.179-.186-.352-.378-.531-.563-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.335-.335-.662-.668-1-1-.655-.667-1.333-1.314-2-1.969-.092-.095-.189-.186-.281-.281-.089-.087-.16-.194-.25-.281-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.276-.276-.566-.539-.844-.813-.058-.056-.098-.131-.156-.188-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.148-.154-.32-.284-.469-.438-.081-.085-.169-.165-.25-.25-.099-.098-.182-.215-.281-.313-.204-.212-.42-.414-.625-.625-.126-.124-.249-.251-.375-.375-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.65-.662-1.307-1.319-1.969-1.969-.15-.15-.318-.288-.469-.438-.081-.085-.169-.165-.25-.25-.104-.103-.208-.21-.313-.313-.179-.186-.352-.378-.531-.563-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.49-.499-.972-1.01-1.469-1.5-.497-.502-1.027-.974-1.531-1.469-.087-.09-.163-.191-.25-.281-.095-.093-.186-.189-.281-.281-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-.335-.335-.662-.668-1-1-.335-.335-.662-.668-1-1-.655-.667-1.333-1.314-2-1.969-.092-.095-.189-.186-.281-.281-.089-.087-.16-.194-.25-.281-.146-.144-.291-.294-.438-.438-.165-.168-.334-.333-.5-.5-.167-.166-.332-.335-.5-.5-27.14-27.15-64.64-43.938-106.06-43.938"
      fill-opacity=".235"
    />
  </g>
  <text x="-1160.48" y="549.52002">
    <tspan
      x="-1160.48"
      y="549.52002"
    />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="28.534"
    y="1642.24"
  />
  <text x="-454.14001" y="393.89001">
    <tspan
      x="-454.14001"
      y="393.89001"
    />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="204.55"
    y="1017.72"
  />
  <text x="-420.76999" y="385.76001">
    <tspan
      x="-420.76999"
      y="385.76001"
    />
  </text>
  <text transform="scale(4.0128 .2492)" x="212.87" y="985.12" />
  <text
    x="-1843.1899"
    y="575.20001"
  >
    <tspan x="-1843.1899" y="575.20001" />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="-141.60001"
    y="1745.3101"
  />
  <text x="-1136.85" y="419.57001">
    <tspan
      x="-1136.85"
      y="419.57001"
    />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="34.423"
    y="1120.79"
  />
  <text x="-1103.47" y="411.45001">
    <tspan
      x="-1103.47"
      y="411.45001"
    />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="42.740002"
    y="1088.1899"
  />
  <g fill-rule="evenodd">
    <path
      d="m256 1c-140.83 0-255 114.17-255 255s114.17 255 255 255 255-114.17 255-255-114.17-255-255-255m8.827 44.931c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9"
      fill-opacity=".067"
    />
    <g fill-opacity=".129">
      <path
        d="m256 4.433c-138.94 0-251.57 112.63-251.57 251.57s112.63 251.57 251.57 251.57 251.57-112.63 251.57-251.57-112.63-251.57-251.57-251.57m5.885 38.556c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9"
      />
      <path
        d="m256 8.356c-136.77 0-247.64 110.87-247.64 247.64s110.87 247.64 247.64 247.64 247.64-110.87 247.64-247.64-110.87-247.64-247.64-247.64m2.942 31.691c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9"
      />
    </g>
    <path
      d="m253.04 7.859c-135.42 0-245.19 109.78-245.19 245.19 0 135.42 109.78 245.19 245.19 245.19 135.42 0 245.19-109.78 245.19-245.19 0-135.42-109.78-245.19-245.19-245.19zm0 26.297c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9z"
      fill="#fff"
      stroke="#000"
      stroke-opacity=".31"
      stroke-width="4.904"
    />
  </g>
  <text x="729.64001" y="231.36">
    <tspan
      x="729.64001"
      y="231.36"
    />
  </text>
  <text transform="scale(4.0128 .2492)" x="378.91" y="579.25" />
  <text
    x="1310.91"
    y="151.36"
  >
    <tspan x="1310.91" y="151.36" />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="523.76001"
    y="258.22"
  />
  <text x="239.33" y="-29.900999">
    <tspan
      x="239.33"
      y="-29.900999"
    />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="256.72"
    y="-469.14001"
  />
  <text x="1337.38" y="-246.37"><tspan x="1337.38" y="-246.37" /></text>
  <text
    transform="scale(4.0128 .2492)"
    x="530.35999"
    y="-1337.8101"
  />
  <text x="1918.65" y="-326.38"><tspan x="1918.65" y="-326.38" /></text>
  <text
    transform="scale(4.0128 .2492)"
    x="675.21002"
    y="-1658.85"
  />
  <text x="1529.53" y="-798.78003">
    <tspan
      x="1529.53"
      y="-798.78003"
    />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="578.23999"
    y="-3554.51"
  />
  <text x="2110.79" y="-878.78003">
    <tspan
      x="2110.79"
      y="-878.78003"
    />
  </text>
  <text
    transform="scale(4.0128 .2492)"
    x="723.09003"
    y="-3875.54"
  />
  <text x="277.98999" y="535.94"><tspan x="277.98999" y="535.94" /></text>
  <g
    fill="#fff"
    fill-rule="evenodd"
  >
    <path
      d="m256 106c-82.84 0-150 67.16-150 150s67.16 150 150 150 150-67.16 150-150-67.16-150-150-150m0 50.15c55.14 0 99.84 44.707 99.84 99.85 0 55.14-44.703 99.85-99.84 99.85-55.14 0-99.84-44.707-99.84-99.85 0-55.14 44.703-99.85 99.84-99.85"
    />
    <rect
      height="130.13"
      rx="25"
      transform="rotate(90)"
      width="50"
      x="231"
      y="-321.06"
    />
  </g>
</svg>
